<via-help-resources-layout>
    <div class="e-column-layout">
        <div class="e-navigation-column">
            <div class="e-fixed-content">

                <h1 class="e-page-title">Frequently Asked Questions</h1>
                <div class="e-most-popular-topics">
                    <h2 class="e-content-heading">Most popular topics</h2>
                    <a *ngFor="let question of faqCollection.popularFaqs"
                        [class.e-active]="selectedFaqId === question.id"
                        (click)="expandPopularFaq(question.id)" tabindex="0">
                        {{question.title}}
                    </a>
                </div>

            </div>
        </div>
        <div class="e-content-column" role="main">
            <mat-accordion class="e-faq-accordion">

                <ng-container *ngFor="let faqGroup of faqCollection.faqGroups">
                    <h2 class="e-content-heading">{{faqGroup.categoryName}}</h2>
                    
                    <div *ngFor="let question of faqGroup.questions">
                        <div [id]="'id' + question.id" class="e-scroll-anchor"></div>

                        <mat-expansion-panel
                            [expanded]="selectedFaqId === question.id"
                            (afterExpand)="scrollToFaq(question)"
                            (afterCollapse)="resetSelectedFaq(question)">
                            <mat-expansion-panel-header>
                                <mat-panel-title>{{question.title}}</mat-panel-title>
                            </mat-expansion-panel-header>
                            <div class="e-faq-content" [innerHTML]="question.description"></div>
                        </mat-expansion-panel>
                    </div>
                </ng-container>

            </mat-accordion>
        </div>
    </div>
</via-help-resources-layout>
